import { routes } from '@/constants/Constants';
import { logger } from '@/shared/libs/logger';
import { hasLogoutStarted } from './logout';

let redirectStarted = false;

/** True once the access message is on its way, so a parallel 401 doesn't replace it with a logout. */
export function hasAccessLimitationStarted(): boolean {
  return redirectStarted;
}

/**
 * A TG session the BFFs refuse for Landlord Portal, such as a renter's. Signing in again would get the same
 * session, so the user sees the access message instead of looping through login.
 */
export function redirectToAccessLimitation(context?: Record<string, unknown>): void {
  // Parallel failing requests can all land here, and a logout may already be leaving: only the first navigates.
  if (redirectStarted || hasLogoutStarted()) {
    return;
  }

  redirectStarted = true;
  logger.info('TG session not allowed for Landlord Portal', context);
  globalThis.location.replace(routes.limitation);
}
